// Credit cost per campaign type. Mirrors the backend's `creditCostFor(...)` so
// the wizard can show "X credit(s)" before /campaigns/pricing/activate is called.
// Must stay in sync with SubscriptionServiceImpl.creditCostFor.
export function creditCostForType(type: string): 1 | 2 | 3 {
    if (type === 'TargetReachCampaign') return 3;
    if (type === 'DrawRoutesCampaign') return 2;
    return 1;
}
